import React, { createContext, useContext, useState, useCallback } from 'react';

// Context for SSE connection status
const SSEContext = createContext({
  isConnected: false,
  tableId: null,
  setConnectionStatus: () => {},
});

// Provider component
export function SSEProvider({ children }) {
  const [isConnected, setIsConnected] = useState(false);
  const [tableId, setTableId] = useState(null);

  const setConnectionStatus = useCallback((connected, id = null) => {
    setIsConnected(connected);
    if (id !== null) {
      setTableId(id);
    }
  }, []);

  return (
    <SSEContext.Provider value={{ isConnected, tableId, setConnectionStatus }}>
      {children}
    </SSEContext.Provider>
  );
}

// Hook to use SSE context
export function useSSEContext() {
  return useContext(SSEContext);
}

export default SSEContext;
